import { addQueryArgs } from '@wordpress/url';
import { getParamsOfUrl, getUrl } from '../mixins/search';

const agentListNode = document.querySelector( '.realpress-agent-list' );
let sortNode, containerNode, searchNode, restUrl, restNamespace, orderby, order;
//Loadmore
const loadMoreWrapperNode = agentListNode.querySelector( '.realpress-load-more' );
let loadmoreBtnNode, loadingNode;

//infinite scroll
const infiniteScrollNode = agentListNode.querySelector( '.realpress-infinite-scroll' );
let infiniteLoadingNode;
//-----------
const paginationType = REALPRESS_GLOBAL_OBJECT.pagination_type || '';
let defaultQuery = { orderby: 'display_name', order: 'asc' };
let query = {};
let isFetching = false;
let nextPage = null;

const init = () => {
	sortNode = agentListNode.querySelector( '.realpress-sort-by select' );
	containerNode = agentListNode.querySelector( '.realpress-agent-list-container' );
	searchNode = document.querySelector( '.realpress-agent-search' );

	restUrl = REALPRESS_GLOBAL_OBJECT.rest_url || '';
	restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';

	if ( typeof REALPRESS_GLOBAL_OBJECT.pll_current_lang !== 'undefined' ) {
		defaultQuery = { ...defaultQuery, pll_current_lang: REALPRESS_GLOBAL_OBJECT.pll_current_lang };
	}

	if ( typeof REALPRESS_GLOBAL_OBJECT.wpml_current_lang !== 'undefined' ) {
		defaultQuery = { ...defaultQuery, wpml_current_lang: REALPRESS_GLOBAL_OBJECT.wpml_current_lang };
	}

	const queryParams = getParamsOfUrl();
	if ( Object.keys( queryParams ).length ) {
		query = { ...query, ...queryParams };
	}

	//Loadmore
	if ( loadMoreWrapperNode ) {
		loadmoreBtnNode = loadMoreWrapperNode.querySelector( '.realpress-load-more-btn' );
		loadingNode = loadMoreWrapperNode.querySelector( '.realpress-loading-display' );
	}

	//Infinite Scroll
	if ( infiniteScrollNode ) {
		infiniteLoadingNode = infiniteScrollNode.querySelector( '.realpress-loading-display' );
	}
};

const realpressAgentList = () => {
	if ( ! agentListNode ) {
		return;
	}
	init();
	getAgents( query );
	pagination();
	sort();
	search();
};

const getAgents = ( queryParam = {}, isLoadmore = false ) => {
	if ( isLoadmore === false ) {
		containerNode.style.opacity = 0.4;
	}

	const param = { ...defaultQuery, ...queryParam };
	fetch( addQueryArgs( restUrl + restNamespace + '/agents', param ), { method: 'GET' } )
		.then( ( response ) => response.json() )
		.then( ( res ) => {
			if ( res.data.content !== undefined ) {
				if ( isLoadmore ) {
					containerNode.insertAdjacentHTML( 'beforeend', res.data.content );
				} else {
					containerNode.innerHTML = res.data.content;
				}
			} else {
				if ( loadMoreWrapperNode ) {
					loadMoreWrapperNode.style.display = 'none';
				}
				if ( res.msg && isLoadmore === false ) {
					containerNode.innerHTML = `<p>${ res.msg }</p>`;
				}
			}

			renderPagination( res );
		} ).catch( ( err ) => {
			console.log( err );
		} ).finally( () => {
			if ( isLoadmore === false ) {
				const urlPush = getUrl( query );
				window.history.pushState( '', '', urlPush );
			}
			containerNode.style.opacity = 1;
		} );
};

const sort = () => {
	if ( ! sortNode ) {
		return;
	}

	sortNode.addEventListener( 'change', function( event ) {
		const selected = event.target.value;
		switch ( selected ) {
		case 'name_asc':
			orderby = 'display_name';
			order = 'asc';
			break;
		case 'name_desc':
			orderby = 'display_name';
			order = 'desc';
			break;
		default:
			orderby = 'ID';
			order = 'desc';
			break;
		}

		query = { ...query, orderby, order };
		//Loadmore and infinite scroll
		if ( paginationType !== 'standard' ) {
			query = { ...query, page: 1 };
		}

		getAgents( query );
	} );
};

const search = () => {
	if ( ! searchNode ) {
		return;
	}
	const searchButton = searchNode.querySelector( 'button' );
	searchButton.addEventListener( 'click', function() {
		handleSearch();
	} );

	const fieldNodes = searchNode.querySelectorAll( 'input' );

	[ ...fieldNodes ].map( ( inputNode ) => {
		inputNode.addEventListener( 'keyup', function( event ) {
			if ( event.keyCode === 13 ) {
				handleSearch();
			}
		} );
	} );
};

const handleSearch = () => {
	if ( ! searchNode ) {
		return;
	}

	const fieldNodes = searchNode.querySelectorAll( 'input,select' );
	if ( ! fieldNodes ) {
		return;
	}
	for ( let i = 0; i < fieldNodes.length; i++ ) {
		const fieldNode = fieldNodes[ i ];
		const name = fieldNode.getAttribute( 'name' );

		if ( fieldNode.value === '' ) {
			if ( query.hasOwnProperty( name ) ) {
				delete query[ name ];
			}
		} else {
			query[ name ] = fieldNode.value;
		}
	}
	query = { ...query, page: 1 };
	getAgents( query );
};
const renderPagination = ( res ) => {
	if ( paginationType === 'standard' ) {
		if ( res.data.pagination !== undefined ) {
			agentListNode.querySelector( '.realpress-pagination' ).innerHTML = res.data.pagination;
		} else {
			agentListNode.querySelector( '.realpress-pagination' ).innerHTML = '';
		}

		if ( res.data.from_to !== undefined ) {
			agentListNode.querySelector( '.realpress-from-to' ).innerHTML = res.data.from_to;
		} else {
			agentListNode.querySelector( '.realpress-from-to' ).innerHTML = '';
		}
	}

	if ( paginationType === 'loadmore' ) {
		nextPage = null;
		if ( res.data.pagination === undefined ) {
			return;
		}

		loadmoreBtnNode.innerHTML = res.data.pagination;
		loadingNode.style.display = 'none';
		if ( res.data.next_page ) {
			nextPage = res.data.next_page;
		} else {
			nextPage = null;
		}
	}

	if ( paginationType === 'infinite_scroll' ) {
		infiniteLoadingNode.style.display = 'none';
		isFetching = false;
		if ( res.data.next_page ) {
			nextPage = res.data.next_page;
		} else {
			nextPage = null;
		}
	}
};

const pagination = () => {
	document.addEventListener( 'click', function( event ) {
		const target = event.target;
		const item = target.closest( 'a' );
		if ( paginationType === 'standard' ) {
			if ( ! item ) {
				return;
			}

			if ( ! item.getAttribute( 'data-page' ) ) {
				return;
			}

			const paginationNode = target.closest( '.realpress-pagination' );
			if ( ! paginationNode ) {
				return;
			}
			event.preventDefault();
			const page = item.getAttribute( 'data-page' );
			query = { ...query, page };
			getAgents( query );
			agentListNode.scrollIntoView( { behavior: 'smooth' } );
		}

		if ( paginationType === 'loadmore' ) {
			if ( target.parentNode !== loadmoreBtnNode ) {
				return;
			}

			event.preventDefault();
			target.remove();
			loadingNode.style.display = 'block';
			query = { ...query, page: nextPage };
			getAgents( query, true );
		}
	} );

	if ( paginationType === 'infinite_scroll' ) {
		window.addEventListener( 'scroll', ( event ) => {
			getScrollData();
		} );
	}
};

const getScrollData = () => {
	const distance = infiniteScrollNode.getBoundingClientRect().top - window.innerHeight;

	if ( isFetching === false && distance < 0 && nextPage ) {
		isFetching = true;
		infiniteLoadingNode.style.display = 'block';
		query = { ...query, page: nextPage };
		getAgents( query, true );
	}
};

export default realpressAgentList;
